import {LOGIN_SUCCEEDED} from "../actionTypes";

/**
 * Tries to retrieve a user from session storage
 * @returns {any}
 */
function initialUser() {
    return sessionStorage.user ? JSON.parse(sessionStorage.user) : null;
}

const initialState = {
    user: initialUser(),
};

export default function (state = initialState, action) {
    switch (action.type) {
        /* Add user */
        case LOGIN_SUCCEEDED: {
            const {user} = action.payload;
            return {
                ...state,
                user
            }
        }
        default:
            return state;
    }
}
